"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DualListboxes = void 0;
var react_1 = __importStar(require("react"));
var SelectComponents_1 = require("./SelectComponents");
var useSelect_1 = require("./useSelect");
var DualListboxes = function (props) {
    var components = __assign(__assign({}, SelectComponents_1.defaultDualListboxComponents), props.components);
    var Container = components.Container, Listbox = components.Listbox, OptionContainer = components.OptionContainer, Option = components.Option;
    var _a = useSelect_1.useSelect(props), highlightedOption = _a.highlightedOption, setHighlightedOption = _a.setHighlightedOption, selectedOptions = _a.selectedOptions, onSelect = _a.onSelect, setSelectedOptions = _a.setSelectedOptions, options = _a.options, flattenedOptions = _a.flattenedOptions, setHighlightedEl = _a.setHighlightedEl;
    var inputValue = react_1.useMemo(function () { var _a; return selectedOptions.map(function (option) { return option.value; }).join((_a = props.valueDelimiter) !== null && _a !== void 0 ? _a : ","); }, [selectedOptions]);
    // EVENT HANDLING
    var onDeselectAllClick = function () {
        setSelectedOptions([]);
    };
    var onSelectAllClick = function () {
        setSelectedOptions(flattenedOptions);
    };
    // RENDERING
    var renderOption = function (option, isSelected) {
        var isHighlighted = option === highlightedOption;
        var ref = isHighlighted ? setHighlightedEl : undefined;
        return (react_1.default.createElement(OptionContainer, { ref: ref, isHighlighted: isHighlighted, onClick: function (e) {
                e.preventDefault();
                onSelect(option);
            }, onMouseEnter: function () { return setHighlightedOption(option); }, onMouseLeave: function () { return setHighlightedOption(undefined); } },
            react_1.default.createElement(Option, { multiple: props.multiple || false, option: option, isHighlighted: isHighlighted, isSelected: isSelected })));
    };
    var renderGroup = function (group, renderSelected) {
        if (!group.options || group.options.length === 0) {
            return null;
        }
        var options = group.options.filter(function (option) { return selectedOptions.includes(option) === renderSelected; });
        if (options.length === 0) {
            return null;
        }
        return __spreadArray([
            react_1.default.createElement("p", { className: "c-dropdown__group" }, group.heading)
        ], options.map(function (option) { return renderOption(option, renderSelected); }));
    };
    var renderOptions = function () {
        if (options.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noOptionsText || "No options available"));
        }
        return options.map(function (option) {
            if ("options" in option) {
                return renderGroup(option, false);
            }
            else {
                if (selectedOptions.includes(option)) {
                    return;
                }
                return renderOption(option, false);
            }
        });
    };
    var renderSelected = function () {
        if (selectedOptions.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noSelectedText || "No selected options"));
        }
        // TODO the order of the options is preserved when rendering selected
        // options. This should be rewritten to keep the order as they were
        // selected.
        return options.map(function (option) {
            if ("options" in option) {
                return renderGroup(option, true);
            }
            else {
                if (!selectedOptions.includes(option)) {
                    return;
                }
                return renderOption(option, true);
            }
        });
    };
    return (react_1.default.createElement(Container, { className: "l-grid +fill +cols-auto u-height-2" },
        react_1.default.createElement(Listbox, null, renderOptions()),
        react_1.default.createElement("div", { className: "u-flex u-align-items-center u-flex-dir-col" },
            react_1.default.createElement("button", { className: "c-button +quiet u-marg-bottom", onClick: onDeselectAllClick }, "< Deselect all  "),
            react_1.default.createElement("button", { className: "c-button +quiet", onClick: onSelectAllClick }, "  Select all   >")),
        react_1.default.createElement(Listbox, null, renderSelected()),
        props.name && react_1.default.createElement("input", { name: props.name, type: "hidden", value: inputValue })));
};
exports.DualListboxes = DualListboxes;
//# sourceMappingURL=DualListboxes.js.map